var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.61 36.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.31,35.21a2,2,0,0,1-1.15-.37C7,26.79,1.18,19.32,1,12.63A11.32,11.32,0,0,1,5.57,3.31,10,10,0,0,1,11.88,1a12.9,12.9,0,0,1,7.43,2.7A13,13,0,0,1,26.73,1a10,10,0,0,1,6.32,2.31,11.29,11.29,0,0,1,4.56,9.32c-.18,6.69-5.94,14.16-17.16,22.21A1.92,1.92,0,0,1,19.31,35.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5cbbd3d3f49d4f541da16d4317573ca8.svg";
export { ForwardRef as ReactComponent };